import React, { JSX } from 'react';
import Carousel from 'react-multi-carousel';
import { useRef, useEffect } from 'react';
import { viewport } from '../../utils/utils';

const CarouselComponent = (props: any): JSX.Element => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 10000, min: 1440 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 1440, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1023, min: 768 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      partialVisibilityGutter: props?.children?.length > 1 ? 48 : 5
    },
    ...(props?.responsive)
  };
  const viewPort = viewport();
  const carouselRef = useRef<any>(null);
  const carouselIndex = parseInt(props?.carouselIndex, 10);
  let mobile = false;

  useEffect(() => {
    const width = window?.innerWidth;
    if (width < 767) {
      mobile = true;
    } else {
      mobile = false;
    }
    setTimeout(() => {
      // if (((!mobile && carouselIndex > 2) || mobile) && props?.children?.length > 1) {
      //   carouselRef.current?.goToSlide(carouselIndex, false);
      // }
    }, 400);
  }, [props?.children?.length]);

  return (
    <Carousel
      responsive={responsive}
      renderButtonGroupOutside={true}
      partialVisible={true}
      swipeable={true}
      autoPlay={false}
      shouldResetAutoplay={false} // this would stop auto play if next button is clicked
      arrows={viewPort === 'mobile' ? (props?.arrow ? true : false) : true}
      showDots={
        viewPort === 'tablet'
          ? props?.children?.length > 2
            ? true
            : false
          : viewPort !== 'tablet' && viewPort !== 'mobile'
          ? props?.children?.length > 3
            ? true
            : false
          : true
      }
      ref={carouselRef}
      customTransition='transform 1s ease'
    >
      {props.children}
    </Carousel>
  );
};

export default CarouselComponent;
